import GameModel from "./GameModel";
import Config from "../../../../../shared/src/ranj/app/config/Config";
import BaseSaveModel from "../../../../../shared/src/ranj/equalture/savegame/BaseSaveModel";

export default class SaveModel extends BaseSaveModel {

    /**
     * 
     * @param {GameModel} gameModel 
     * @param {Config} config 
     */
    constructor(gameModel, config) {
        super(config);
        this._gameModel = gameModel;
    }

    _createMinigameSaveGame() {
        const obj = this._gameModel.getSnapshot();
        return obj;
    }
};
